const primaryColor = '#5368C1';
const darkPrimaryColor = '#1C3055';


const config = {
    media: {
        player: {
            styling: {
                colors: {
                    waveColor: primaryColor,
                    progressColor: darkPrimaryColor,
                    loaderColor: darkPrimaryColor,
                    cursorColor: 'navy',
                },
            },
        },
    },
};

export default config;
